import { ApolloError } from 'apollo-boost'
import { ILoggerContext } from '~/module/logger/loggerPlugin'

interface ApolloErrorMetadata {
  userId: string | string[] | undefined
  shopId: string | string[] | undefined
  userAgent: string | string[] | undefined
  isBot: boolean | undefined
}

export default (error: Error, nuxtContext: ILoggerContext) => {
  const loggedError = error as Error & ApolloError & ApolloErrorMetadata
  loggedError.userAgent = nuxtContext.req?.headers['user-agent']
  loggedError.userId = nuxtContext.app.$shopConfig?.user?.id
  loggedError.shopId = nuxtContext.app.$shopConfig?.shopId
  loggedError.isBot = nuxtContext.app.$shopConfig?.isBot

  // get rid of annoying Monolith networkErrors during development
  const isDev = (nuxtContext.$env?.nodeEnv ?? '') === 'development'
  const skippedUrls = ['/api/widgets/getWidgetsData']
  const shouldLog =
    !isDev &&
    skippedUrls.includes((loggedError as any).networkError?.config?.url)

  if (shouldLog) {
    nuxtContext.logger.error(loggedError)
  }
}
